import type { ComponentIR } from "../ir.js";
import type { GeneratedFile, GenerateOptions, Generator } from "./types.js";

export const embeddedDslGenerator: Generator = {
  generate(ir: ComponentIR, options: GenerateOptions): GeneratedFile[] {
    if (!ir.embeddedDslDir || !options.resolvedDslData) {
      return [];
    }

    const content = `/** Auto-generated by @aaac/contracts. Do not edit. */

export const resolvedDsl: Record<string, unknown> = ${JSON.stringify(options.resolvedDslData, null, 2)} as const;
`;

    return [
      {
        path: "dsl-data.ts",
        content,
        overwrite: true,
        targetDir: ir.embeddedDslDir,
      },
    ];
  },
};
